export default __webpack_public_path__ + "static/media/landing_community.906d9ba4.jpg";